import { Stack } from "@mui/material";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { WorkerShiftCard } from "@src/appV2/redesign/Shift/WorkerShift/Card";
import { BottomSheet, Text, type UseModalState } from "@src/appV2/redesign/system/ui-components";
import { shiftPeriodToTimeSlot } from "@src/appV2/Shifts/Shift/types";

import { type SupportShiftDetails } from "../../api/useShiftDetails";

interface SupportAttendanceConfirmationBottomSheetProps {
  modalState: UseModalState;
  shiftDetails: SupportShiftDetails;
  onConfirmAttendance: () => void;
  onDeclineAttendance: () => void;
}

export function SupportAttendanceConfirmationBottomSheet(
  props: SupportAttendanceConfirmationBottomSheetProps
) {
  const { modalState, shiftDetails, onConfirmAttendance, onDeclineAttendance } = props;

  useLogEffect(
    APP_V2_USER_EVENTS.GUIDED_SUPPORT_ATTENDANCE_CONFIRMATION_VIEWED,
    { shiftId: shiftDetails.id },
    { enabled: modalState.modalIsOpen }
  );

  return (
    <BottomSheet modalState={modalState}>
      <Stack spacing={6} sx={{ paddingX: 5, paddingTop: 8 }}>
        <Text semibold variant="h3">
          Are you reaching out about canceling this shift?
        </Text>
        <WorkerShiftCard
          shiftId={shiftDetails.id}
          workplaceId={shiftDetails.workplaceId}
          workplaceName={shiftDetails.workplaceName}
          workplaceTimezone={shiftDetails.workplaceTimezone}
          workplaceRequiresLunchBreak={false}
          shiftTimeSlot={shiftPeriodToTimeSlot[shiftDetails.shiftPeriod]}
          shiftStart={shiftDetails.startAt}
          shiftEnd={shiftDetails.endAt}
          shiftQualificationName={shiftDetails.qualificationName ?? ""}
        />
      </Stack>
      <DialogFooter orientation="vertical" sx={{ marginTop: 6 }}>
        <Button fullWidth variant="destructive" size="large" onClick={onDeclineAttendance}>
          I am no longer able to attend this shift
        </Button>
        <Button fullWidth variant="contained" size="large" onClick={onConfirmAttendance}>
          I am still able to attend this shift
        </Button>
      </DialogFooter>
    </BottomSheet>
  );
}
